module.exports = __webpack_public_path__ + "loader-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Images/loader-logo.png
// module id = 1089
// module chunks = 22